import Vue from 'vue'
import VueSocketIO from 'vue-socket.io';
import settings from '../../settings'
import store from '../store'
import SocketIO from 'socket.io-client'

Vue.use(new VueSocketIO({
  debug: true,
  connection: SocketIO(settings.baseApi),
  vuex: {
    store,
    mutationPrefix: "SOCKET_",
    actionPrefix: "SOCKET_"
  }
}))
